import { getJson } from "@/utils/routeUtils";
import type { UserInfo } from "@/utils/types";
import { queryOptions } from "@tanstack/react-query";

export const userOptions = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return queryOptions({
    queryKey: ["user"] as const,
    queryFn: async (): Promise<UserInfo | null> => {
      const { data, error } = await getJson("/api/user", {});
      if (error || !data) return null;
      return data;
    },
    enabled,
  });
};
